"use client";
import styled from "../../../client-utils/styled/index.js";
import ToggleButtonGroup from "../../../components/atoms/ToggleButtonGroup/index.js";
import ToggleButton from "../../../components/atoms/ToggleButton/index.js";
const coreComponentName = "SdbToggleList";
export const Root = styled(ToggleButtonGroup, { name: coreComponentName, slot: "Root" })({});
export const Button = styled(ToggleButton, { name: coreComponentName, slot: "Button" })({});
